import {Partner} from '../../model/admin/partner';
import {BaseResponse} from '../internal/baseresponse';
export class ADMReportPartnerResult extends BaseResponse {
  data: Array<Partner>;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admreportpartnerresult.ts